import React, { 
  useCallback, useContext, useEffect, 
  useState, useMemo, ReactElement, useRef, forwardRef,
  useImperativeHandle
} from 'react';
import {
  useMediaQuery,
  Box, IconButton, Button, Hidden, SvgIcon,
} from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import GetAppIcon from '@mui/icons-material/GetApp';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import { red, lightGreen, deepPurple, grey } from '@mui/material/colors';

// -----------------------react-pdf-viewer相关组件的引用----------------------------------
import { 
  Viewer, Worker, SpecialZoomLevel, LocalizationMap, ThemeContext,
  RenderPage,
  RenderPageProps,
  PageSize,
  PluginFunctions,
} from '@react-pdf-viewer/core';
import { defaultLayoutPlugin, ToolbarProps, ToolbarSlot,  } from '@react-pdf-viewer/default-layout';
import { zoomPlugin } from '@react-pdf-viewer/zoom';

import rdv_ZH from '@react-pdf-viewer/locales/lib/zh_CN.json';  // 简体中文
import rdv_EN from '@react-pdf-viewer/locales/lib/en_US.json';  //  英文

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';


// -----------------------------end---------------------------------------------------------

//  ---------------------手势缩放功能 组件--------------------------------
// import { useGestureResponder } from 'react-gesture-responder';

//  ----------------------------end--------------------------------------
import Loader from '../loaders';
import PopperMenu from '../../documents/poperMenu';

import { useTranslation } from 'react-i18next';
import _, { isEmpty, isNull, name } from 'lodash';

import './style.css';
import { DownloadFile, getFileSuffix } from '@ivymobi/orbit-core';
import { useDispatch } from 'react-redux';
function HomeIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} >
      <circle fill='#00A800' cx="142" cy="142" r="139.1"/>
      <g>
        <path  d="M142,54.8c-55,0-99.6,37.4-99.6,83.4c0,19.4,7.8,37.2,21,51.2l0,0c0,0-1,35.2-8.4,39.8c0,0,27,0,44.2-15.6
          c13,5.2,27.4,8,42.8,8c55,0,99.6-37.4,99.6-83.4S197,54.8,142,54.8z M142,213.6c-14,0-27.4-2.6-39.8-7.4c-1-0.4-2-0.6-3-0.6
          c-2,0-3.8,0.8-5.4,2c-7.6,7-17.8,10.4-25.8,12c0.8-3.2,1.4-6.8,1.8-11c1-7.8,1.4-15.2,1.4-18c0.4-2.4-0.4-4.8-2-6.6
          c-12.4-13.2-19-29-19-45.8c0-41.6,41.2-75.4,91.6-75.4c50.6,0,91.6,33.8,91.6,75.4C233.6,179.8,192.6,213.6,142,213.6z"/>
        <path  d="M179.8,107.4h-75.6c-2.2,0-4,1.8-4,4s1.8,4,4,4h75.6c2.2,0,4-1.8,4-4S182,107.4,179.8,107.4z"/>
        <path  d="M179.8,138h-75.6c-2.2,0-4,1.8-4,4c0,2.2,1.8,4,4,4h75.6c2.2,0,4-1.8,4-4C183.8,139.8,182,138,179.8,138z"/>
        <path  d="M179.8,168.6h-75.6c-2.2,0-4,1.8-4,4s1.8,4,4,4h75.6c2.2,0,4-1.8,4-4S182,168.6,179.8,168.6z"/>
      </g>
    </SvgIcon>
  );
}

const useStyles = makeStyles((theme: Theme) =>{
  return createStyles({
    main:{
      '--maincolor':theme.palette.primary.main
    },
    selectRoot: {
      width: '110px',
      margin: '0 12px',
    }
  })
}
  
);

// Create the error component
const renderError = (error) => (
  <div
    style={{
      alignItems: 'center',
      border: '1px solid rgba(0, 0, 0, 0.3)',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      justifyContent: 'center',
      width: '100%',
    }}
  >
    <div style={{ color: 'red', fontSize: '24px', marginBottom: '.5rem' }}>
      Error: {error.message}
    </div>
  </div>
);



const ReactPdfViewer = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch()
  const { 
    parentRef, document, share, tenant, user, setMode, eoi, leadProfile, 
    handleDownload, handleSendToEmail, onLikeFormOpen,setLoginMode,
    onClose = () => console.log('closeAction'),
    errorPlugin = () => renderError,
  
  } = props;

  // const viewerRef = useRef(null);
  // PluginFunctions
  // console.log('viewerRefviewerRefviewerRef', viewerRef);
  // if (viewerRef && viewerRef.current) {
  //   const scale = viewerRef.current.getScale();
  //   console.log('Current scale:', scale);
  // }

  const PDF_URL = _.get(document, ['asset', 'url'], '');  // pdf的cdn路径
  const matches = useMediaQuery('(min-width: 600px)');
  // console.log({PDF_URL});

  // 父组件宽度，默认block元素100%，不需要额外设置
  // const  parentWidth = _.get(parentRef, ['current', 'clientWidth'], '100%');
  // parentHeight： 父组件高度，pdf浏览器组件默认和（flex格式，自动填满空白区域的）父组件高度相等
  const parentHeight = _.get(parentRef, ['current', 'clientHeight'], '100') + 'px';
  // 是否是分享页面的pdf预览组件  判断可以加到上一层组件上
  const isShare = useMemo(() => {
    return !_.isNil(share) && !_.isEmpty(share);
  }, [share]);
  // 是否显示下载按钮的判断逻辑
  const DownLoadable =  useMemo(() => {
    console.log("documents=====",document,share)
    return (document.acl?.downloadable??true) && ((!share)?true:share.acl?.downloadable);
  }, [document, share]);
  // console.log({document}, {share}, {isShare});

  // ------------------------theme 相关的设置和方法-------------------------------
  const [currentTheme, setCurrentTheme] = useState('dark');
  const themeContext = {currentTheme, setCurrentTheme};


  // ------------------------theme  end------------------------------------------

  // ----------------------下载弹框相关------------------------------------------
  const [menuOpen, setMenuOpen] = useState(false);
  const anchorRef = useRef<HTMLButtonElement>(null);
  const handleDownloadToggle = () => {
    if((isEmpty(user)||isNull(user)) && (!_.isEmpty(eoi) && eoi.includes('download'))){
      setLoginMode('normal')
      return;
    }

    const eoihasDownload = !_.isEmpty(eoi) && eoi.includes('download');
    console.log(")))))))))))))))))",eoi,eoihasDownload,leadProfile)
    // 下载需要填写信息，且没填写过信息时
    if ( eoihasDownload && (leadProfile?.popUp??true) ) {
      setMode('download');
      return;
    }
    setMenuOpen((prevOpen) => !prevOpen);
  };
  // -------------------------下载弹框相关  end -------------------------------------

  // ---------------------------test-----------------------------
  const testMemo = useMemo(() => {
    // console.log('执行memohook 执行memohook');
    return '111';
  }, [document]);

  // console.log('testMemotestMemotestMemo', testMemo);

  const type = 'pdf';
  const file = '/files/bmecat.pdf';
  const onError = (e) => {
    console.log(e, "error in file-viewer");
  };
  // --------------------------test    end---------------------------------


  // -------------------------默认的layout组件，headerbar  sidebar等-----------------------------
  // TODO: 手机端优化，添加一个‘更多’的icon，在手机模式下将 缩放 全屏 下载 主题等等功能全部收进更多中
  const renderToolbar = (Toolbar: (props: ToolbarProps) => ReactElement) => {
    return (
      <Toolbar>
        {(slots: ToolbarSlot) => {
          const {
            CurrentPageInput,   //  输入页码输入框
            // CurrentPageLabel,  //  当前页数
            CurrentScale,   // 当前pdf的scale比例
            Download,  //   icon形式的下载
            // DownloadMenuItem,   // MenuItem： 下拉菜单子选项形式——的下载按钮
            EnterFullScreen,  //  icon 形式全屏功能
            // EnterFullScreenMenuItem,  //  下拉菜单子选项形式的全屏按钮
            // GoToFirstPage,    // icon 形式的跳转到首页
            // GoToFirstPageMenuItem,    //下拉菜单子选项形式的跳转到首页
            // GoToLastPage,    //  icon 形式的跳转到尾页
            // GoToLastPageMenuItem,    // 下拉菜单子选项形式的跳转到尾页
            GoToNextPage,    // icon： 下一页
            // GoToNextPageMenuItem,    // menuitem： 下一页
            GoToPreviousPage,    // icon: 上一页
            // GoToPreviousPageMenuItem,    // menuitem： 上一页
            NumberOfPages,    //  文字，总页数
            // Open,    //  icon: 打开一个本地的文件
            // OpenMenuItem,    // menuitem： 打开文件
            // Print,    // icon： 打印
            // PrintMenuItem,    // menuitem： 打印
            // Rotate,    // icon: 顺时针旋转
            // RotateBackwardMenuItem,    // menuitem： 逆时针旋转
            // RotateForwardMenuItem,    // menuitem： 顺时针旋转
            // ShowProperties,    // icon： 显示属性
            // ShowPropertiesMenuItem,    // menuitem： 显示属性
            ShowSearchPopover,    // icon： 搜索功能
            // SwitchScrollMode,    // icon： 垂直滚动
            // SwitchScrollModeMenuItem,    // menuitem： 垂直滚动
            // SwitchSelectionMode,    // icon： 文本选择工具（箭头）
            // SwitchSelectionModeMenuItem,    // menuitem： 文本选择工具（箭头）
            SwitchTheme,    // icon： 切换主题
            // SwitchThemeMenuItem,    // menuitem： 切换主题

            Zoom,    //  文字： 当前比例
            ZoomIn,    //  icon： 比例缩小
            // ZoomInMenuItem,    // menuitem： 比例缩小
            ZoomOut,    // icon： 比例放大
            // ZoomOutMenuItem,    // menuitem： 比例放大
          } = slots;
          return <>
            {/*手机端 */}
            {!matches && <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'center', width: '100%', height: '100%', justifyContent:'space-between'}}>  
              <Box style={{display:'flex', alignItems: 'center',}}>
                <IconButton 
                  size='small' 
                  component="span" 
                  className='viewer_iconbutton' 
                  style={{ padding: '8px 6px', marginLeft:'8px' }} 
                  onClick={() => onClose()}
                >
                  <ArrowBackIosIcon />
                </IconButton>
                <ShowSearchPopover />

                {/* 跳转到 / 总页数 */}
                <CurrentPageInput /> 
                <span className='rpv-toolbar__label'>/<NumberOfPages />
                </span>
              </Box>
              <Box style={{display:'flex', alignItems: 'center'}}>
                {/* 缩小  */}
                <ZoomOut >
                  {(props) => (
                    <IconButton
                      className='columnGroup'
                      aria-label='缩小'
                      onClick={props.onClick}
                      size="large">
                      <RemoveIcon />
                    </IconButton>
                  )}
                </ZoomOut>
              {/* 当前比例 */}
              <Zoom levels={[0.4, 0.8,1.0, 1.2, 1.5]}/>
              {/* 放大 Hidden smDown: 手机端隐藏 */}
              <ZoomIn>
                  {(props) => (
                    <IconButton className='columnGroup' onClick={props.onClick} size="large">
                      <AddIcon />
                    </IconButton>
                  )}
              </ZoomIn>
              {/* 感兴趣  isShare: 分享页面展示该按钮 */}
              {isShare && <IconButton
                style={{width:'40px',height:'40px',marginLeft:'20px'}}
                className='columnGroup'
                ref={anchorRef}
                aria-controls={menuOpen ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                onClick={onLikeFormOpen}
                size="large">
                <HomeIcon style={{width:'33px',height:'33px'}} width='102px' height='102px' viewBox='0 0 284 284'/>  
              </IconButton>}
              {/* <Download /> */}
              {/* 下载 */}
              {DownLoadable && <IconButton
                style={{width:'40px',height:'40px'}}
                  className='columnGroup'
                  ref={anchorRef}
                  aria-controls={menuOpen ? 'menu-list-grow' : undefined}
                  aria-haspopup="true"
                  onClick={()=>{
                    if(handleDownload)
                      handleDownload(document)
                    else{
                      DownloadFile(document.asset.url,document.name+getFileSuffix(document.name,document?.asset?.name),window,dispatch) 
                    }
    

                }}
                size="large">
                <GetAppIcon />
                {/* <HomeIcon style={{width:'35px',height:'35px'}} width='102px' height='102px' viewBox='0 0 1024 1024'/> */}
              </IconButton>}
              {/* 选择下载方式的下拉弹框 */}
              <PopperMenu
                anchorRef={anchorRef}
                document={document}
                menuOpen={menuOpen} 
                setMenuOpen={setMenuOpen}
                handleDownload={handleDownload}
                handleSendToEmail={handleSendToEmail}
              />
              </Box>

                
              </div>}
              {/*电脑端*/ }
              {matches && <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'center', width: '100%', height: '100%' }}>  
                <IconButton 
                  size='small' 
                  component="span" 
                  className='viewer_iconbutton' 
                  style={{ padding: '8px 6px', marginLeft:'8px' }} 
                  onClick={() => onClose()}
                >
                  <ArrowBackIosIcon />
                </IconButton>
                <ShowSearchPopover />
                {/* 上一页*/}
                <div style={{ padding: '0px 2px', marginLeft: 'auto' }}>
                  <GoToPreviousPage />
                </div>
                {/* 跳转到 / 总页数 */}
                <CurrentPageInput /> 
                <span className='rpv-toolbar__label'>/<NumberOfPages />
                </span>
                {/* 下一页 */}
                <div style={{ padding: '0px 2px', marginRight: '8px' }}>
                  <GoToNextPage />
                </div>
                {/* 缩小  */}
                <ZoomOut >
                  {(props) => (
                    <IconButton
                      className='columnGroup'
                      aria-label='缩小'
                      onClick={props.onClick}
                    >
                      <RemoveIcon />
                    </IconButton>
                  )}
                </ZoomOut>
                {/* 当前比例 */}
                <Zoom  levels={[0.4, 0.8, 1.0, 1.2, 1.5]}/>
                {/* 放大 Hidden smDown: 手机端隐藏 */}
                {/* <ZoomIn /> */}
                <ZoomIn>
                  {
                    (props) => {
                      // console.log('propspropspropsprops', props);
                      return (
                        <IconButton
                          className='columnGroup'
                          onClick={props.onClick}
                        >
                          <AddIcon />
                        </IconButton>
                      );
                    }
                  }
                </ZoomIn>
                {/* 全屏 Hidden smDown: 手机端隐藏 */}
                <EnterFullScreen />
                {/* <Open /> */}
                {/* 感兴趣  isShare: 分享页面展示该按钮 */}
                {isShare && <Box className='spliceItem'>
                  <Button 
                    size='small'
                    variant='contained'
                    // disabled={isPreview}
                    style={{ borderRadius: '16px', backgroundColor: '#39AC4A', color: 'white' }}
                    onClick={onLikeFormOpen}
                  >
                    {t('YBT-ADMIN.YBT-ADMIN-030101.YBT-ADMIN-03010120')}
                  </Button>
                </Box>}
                {/* <Download /> */}
                {/* 下载 */}
                {DownLoadable && <IconButton
                  className='columnGroup'
                  ref={anchorRef}
                  aria-controls={menuOpen ? 'menu-list-grow' : undefined}
                  aria-haspopup="true"
                  onClick={()=>{
                  if(handleDownload)
                    handleDownload(document)
                  else{
                    DownloadFile(document.asset.url,document.name+getFileSuffix(document.name,document?.asset?.name),window,dispatch) 
                  }
                   

                }}
                size="large">
                <GetAppIcon />
              </IconButton>}
              {/* 选择下载方式的下拉弹框 */}
              <PopperMenu
                anchorRef={anchorRef}
                document={document}
                menuOpen={menuOpen} 
                setMenuOpen={setMenuOpen}
                handleDownload={handleDownload}
                handleSendToEmail={handleSendToEmail}
              />
              {/* 切换主题 Hidden smDown: 手机端隐藏 */}
              <SwitchTheme />
              {/* <Print /> */}
            </div>}
          </>;
        }}
      </Toolbar>
    );
  };
  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    toolbarPlugin: {
      fullScreenPlugin: {
          getFullScreenTarget: (pagesContainer) => pagesContainer.closest('[data-testid="default-layout__body"]'),
          renderExitFullScreenButton: (props) => <></>,
      },
  },
    // sidebarTabs 默认有三个按钮， 0：缩略图  1：书签  2： 附件
    sidebarTabs: (defaultTabs) => {
      // defaultTabs[0]['title'] = '';
      // console.log({defaultTabs});
      return [
        defaultTabs[0],  //  Thumbnails
      // defaultTabs[1],  //  bookmarks
      // defaultTabs[2],  //  attachments
      ];
    },
    // pdf 顶部toolbar组件
    renderToolbar,
  });
  const { activateTab, toolbarPlugin } = defaultLayoutPluginInstance;
  // 默认打开缩略图目录  可能需要判断web和手机端
  // activateTab(0);
  // console.log('toolbarPlugintoolbarPlugintoolbarPlugin', toolbarPlugin);
  // console.log('PageSizePageSizePageSizePageSize', PageSize)

  // ----------------------------end-------------------------------------------

  // ----------------pdf阅读器多语言设置--------------------
  const [t, local] = useTranslation();
  const languageCode = local.language === 'zh-CN' ? 'zh' : local.language || 'zh';
  const RPV_Language = languageCode === 'zh' ? rdv_ZH : rdv_EN;
  // ----------------- end ----------------------------

  // ------------------------------水印功能的 参数及函数式组件----------------------------------

  // const [hasWaterMark, setHasWaterMark] = useState(true);   //  是否显示水印
  const hasWaterMark = useMemo(() => {  //  是否显示水印
    if (_.isNil(document.acl?.watermarkable)) return false;
    return document.acl.watermarkable;
  }, [document]);

  // const [waterText, setWaterText] = useState('水印文字测试');  // 水印文字
  const waterText = useMemo(() => {  // 水印文字
    return tenant?.profile?.name? (tenant?.profile.name + '\n' + (user?.user? user.user.phone : '')): user?.user ? user.user.phone : '样本通';
  }, [tenant, user]);


  const renderPage: RenderPage = (props: RenderPageProps) => {
    // console.log('renderPagerenderPagerenderPagerenderPagerenderPagerenderPagerenderPage', props);
    if (hasWaterMark) {
      return (
        <>
          {props.canvasLayer.children}
          <div
            style={{
              alignItems: 'center',
              display: 'flex',
              height: '100%',
              justifyContent: 'center',
              left: 0,
              position: 'absolute',
              top: 0,
              width: '100%',
            }}
          >
            <div
              style={{   // 水印文字的样式
                color: 'rgba(0, 0, 0, 0.2)',
                fontSize: `${4 * props.scale}rem`,
                fontWeight: 'bold',
                textTransform: 'uppercase',
                transform: 'rotate(-45deg)',
                userSelect: 'none',
              }}
            >
              {waterText}
            </div>
          </div>
          {props.annotationLayer.children}
          {props.textLayer.children}
        </>
      );
    }
    return (
      <>
        {props.canvasLayer.children}
        {/* {props.svgLayer.children} */}
        {props.annotationLayer.children}
        {props.textLayer.children}
        
      </>
    );
  };
  // ----------------- end ----------------------------
  
  // ----------------手势缩放功能-------------------
  


  // -----------------------------------------------
  
  // ---------------------zoom相关--------------------------
  const zoomPluginInstance = zoomPlugin();
  const { ZoomInButton, ZoomOutButton } = zoomPluginInstance;

  // ---------------------end-------------------------------


  // 需要开放的参数/方法/回调等等
  // 参数： 整体的宽高： width height

  // 方法：


  // 回调：
  


  // 没有数据
  if (_.isEmpty(PDF_URL) || _.isUndefined(PDF_URL)) return <Loader />; 

  // 
  return (
    <ThemeContext.Provider value={themeContext}>
      <Box
        className={classes.main}
        // className={currentTheme === 'light' ? 'lightRoot' : 'darkRoot'}
        style={{ 
          display: 'flex',
          flexDirection: 'column',
          height: parentHeight, 
          width: '100%',
          overflow: 'hidden',
          minHeight: '500px' 
        }}
      >
        <Worker workerUrl="/js/pdfjs-dist@2.6.347.worker.min.js">
          <Viewer 
            // ref={viewerRef}
            // fileUrl="/files/bmecat.pdf"  // 文件url
            // isCompressed: boolean;
            // url: string;
            // 字体文件缺失导致的文字不能全部显示   url地址也可以切换为本地缓存的文件: public/pdf/cmaps/  注意 路径最后加斜线。 字体文件已经全部下载本地留档
            characterMap={{
              // cMapUrl: "https://cdn.jsdelivr.net/npm/pdfjs-dist@3.10.111/cmaps/",
              // cMapPacked: true
              url: "https://cdn.jsdelivr.net/npm/pdfjs-dist@2.6.347/cmaps/",
              isCompressed: true
            }} 
            fileUrl={PDF_URL}  // 文件url
            defaultScale={SpecialZoomLevel.PageFit}  // 默认文本缩放比例
            defaultFontName="Arial" // 设置默认字体为 Arial
            plugins={[defaultLayoutPluginInstance]}   // 组件
            theme={currentTheme}  // 主题
            renderPage={renderPage}   // 水印slot
            renderError={errorPlugin} // 组件报错
            localization={RPV_Language}  // 多语言

            onZoom={(zoom) => console.log({zoom})}
            // errorSlot={}
          />
        </Worker>
      </Box>
    </ThemeContext.Provider>
  );

};
ReactPdfViewer.displayName = 'ReactPdfViewer';
export default ReactPdfViewer;